import Route from '@ember/routing/route';

import type { LibraryClientsEditModel } from '../../client';

export default class LibraryClientsClientEditBrandingRoute extends Route {
  controllerName = 'library.clients.client.edit';

  model(): LibraryClientsEditModel {
    return this.modelFor(
      'library.clients.client.edit'
    ) as LibraryClientsEditModel;
  }
}
